<template lang="pug">
div
  v-btn.mb-4(@click="notifyEmployer")
    | submit to employer
  FlowEditor(:flow-aliases="aliases", show-not-passed)
</template>

<script>
import FlowEditor from "@/components/FlowEditor";

export default {
  name: "flow_editor",

  components: {
    FlowEditor,
  },

  data: () => ({
    aliases: ["candidate"],
  }),

  methods: {
    notifyEmployer() {
      this.axios
        .get("/candidate/sponsorship/candidate_submit")
        .then(() => {
          this.$message.success("Employer successfully notified");
        })
        .catch((err) => {
          this.$message.errorFromServer(err);
        });
    },
  },
};
</script>